module.exports = __webpack_public_path__ + "static/solution3-fd1864da6d69422e68ff75a452df09f3.png";